<template>
    <v-expansion-panel>
        <v-expansion-panel-content>
          <template v-slot:header>
            <h3 class="display-1">Project Report</h3>
          </template>
          <v-card class="pa-4">
            <v-layout row wrap>
              <v-flex d-flex xs12 md6 lg6>
                <v-card color="indigo lighten-2" light>
                  <v-card-title class="title white--text">
                    10 Project By Highest Budget 
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="headers"
                      :items="indexData.projectByBudget"
                      hide-actions
                      :expand="true"
                      :loading="isLoading"
                      :disable-initial-sort="true"
                      class="elevation-1"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.title }}</td>
                        <td class="text-xs-right">{{ props.item.value }}</td>
                        <!-- <td class="text-xs-right">{{props.item.percentage}}</td> -->
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 md6 lg6>
                <v-card color="indigo lighten-2" light>
                  <v-card-title class="title white--text">
                    10 Project By Highest Response
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="headers"
                      :items="indexData.projectByRank"
                      hide-actions
                      :loading="isLoading"
                      :expand="true"
                      :disable-initial-sort="true"
                      class="elevation-1"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.title }}</td>
                        <td class="text-xs-right">{{ props.item.value }}</td>
                        <!-- <td class="text-xs-right">{{props.item.percentage}}</td> -->
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import { mapGetters } from "vuex";  

export default ({
    data: () => ({
        headers: [
            { text: "Title", value: "title", sortable: false },
            { text: "Value", value: "value", align: "right" },
            // { text: '%', value: 'percentage', align: 'right' },
        ],
        project_budget: [
            {
                "title": "Survey on Surveys",
                "value": "25000"
            },
            {
                "title": "Survey on mobile phones",
                "value": "15000"
            },
            {
                "title": "Survey on Foot Traffic safety",
                "value": "7000"
            },
            {
                "title": "Test new project",
                "value": "1000"
            }
        ],
    }),

    mounted() {
      this.fetchReport();
    },

    computed: {
        ...mapGetters(["isLoggedIn","indexData"]),
        isLoading: function() {
            return this.indexData.length == 0 ? true : false;
        },
    },

    methods: {
      async fetchReport() {
        await this.$store.dispatch("setIndexData", ["project-report"]);
        // this.updateCharts();
      },

      async updateCharts() {   
        this.dynamicBlock = this.indexData.dynamic_block;
      }
    }
});
</script>